import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ProfileService } from '@shared/services/api/profile.service';
import { NGXLogger } from 'ngx-logger';
import { Observable, catchError, of, switchMap } from 'rxjs';

export const firstLoginGuard: CanActivateFn = (): Observable<boolean> => {
  const profileService = inject(ProfileService);
  const logger = inject(NGXLogger);
  const router = inject(Router);

  return profileService.profile$.pipe(
    switchMap((user) => {
      if (user.isNewUser) {
        router.navigate(['/change-password']);
        return of(false);
      }
      return of(true);
    }),
    catchError((error) => {
      logger.info('[FirstLogin guard] checking user:', error);
      return of(false);
    })
  );
};
